import { ProductTypeEnum } from '../enums/product-capture.enums';
import { DropDownOption } from '../interfaces/drop-down-option.interface';

export enum BaseTypeEnum {
  NONE = 'NONE',
  DELTA_N = 'DELTA_N',
  BONUS_CERTIFICATE = 'BONUS_CERTIFICATE',
  BONUS_CERTIFICATE_NO_BARRIER = 'BONUS_CERTIFICATE_NO_BARRIER',
  DISCOUNT_CERTIFICATE = 'DISCOUNT_CERTIFICATE',
  DROPBACK_CERTIFICATE = 'DROPBACK_CERTIFICATE',
  BARRIER_DISCOUNT_CERTIFICATE = 'BARRIER_DISCOUNT_CERTIFICATE',
}

export const PARTICIPATION_BASE_TYPE: DropDownOption[] = [
  { id: BaseTypeEnum.NONE, displayValue: 'None' },
  { id: BaseTypeEnum.DELTA_N, displayValue: 'Delta N' },
  { id: BaseTypeEnum.BONUS_CERTIFICATE, displayValue: 'Bonus Certificate' },
  {
    id: BaseTypeEnum.BONUS_CERTIFICATE_NO_BARRIER,
    displayValue: 'Bonus Certificate No Barrier',
  },
  {
    id: BaseTypeEnum.DISCOUNT_CERTIFICATE,
    displayValue: 'Discount Certificate',
  },
  {
    id: BaseTypeEnum.BARRIER_DISCOUNT_CERTIFICATE,
    displayValue: 'Barrier Discount Certificate',
  },
  {
    id: BaseTypeEnum.DROPBACK_CERTIFICATE,
    displayValue: 'Drop-Back Certificate',
  },
];

function getBaseTypeItemsByIds(ids: BaseTypeEnum[]): DropDownOption[] {
  return PARTICIPATION_BASE_TYPE.filter((item) => ids.includes(item.id));
}

export const PRODUCT_BASE_TYPES = new Map<
  ProductTypeEnum | '',
  DropDownOption[]
>([
  ['', PARTICIPATION_BASE_TYPE],
  [
    ProductTypeEnum.BONUS_CERTIFICATE,
    getBaseTypeItemsByIds([
      BaseTypeEnum.BONUS_CERTIFICATE,
      BaseTypeEnum.BONUS_CERTIFICATE_NO_BARRIER,
    ]),
  ],
  [
    ProductTypeEnum.DISCOUNT_CERTIFICATE,
    getBaseTypeItemsByIds([
      BaseTypeEnum.DISCOUNT_CERTIFICATE,
      BaseTypeEnum.BARRIER_DISCOUNT_CERTIFICATE,
    ]),
  ],
  [
    ProductTypeEnum.CAPPED_FLOOR_DELTA_N,
    getBaseTypeItemsByIds([BaseTypeEnum.DELTA_N]),
  ],
  [
    ProductTypeEnum.DROPBACK_CERTIFICATE,
    getBaseTypeItemsByIds([BaseTypeEnum.DROPBACK_CERTIFICATE]),
  ],
]);
